import React from 'react';

const Serie = props => {
    return (
        <svg {...props}>
            <path d="M 16.4,2.55 3.07,10.1 16,17 16.9,15.5 6.75,10 17.3,4.1 Z" />
            <rect width="7.12" height="5.61" x="0.301" y="7.14" ry="1.41" />
            <rect ry="1.41" y="1.45" x="12.6" height="5.61" width="7.12" />
            <rect width="7.12" height="5.61" x="12.6" y="12.6" ry="1.41" />
        </svg>
    );
};
export default Serie;
